import { render, staticRenderFns } from "./select_config.vue?vue&type=template&id=a52145ee&scoped=true"
import script from "./select_config.vue?vue&type=script&lang=js"
export * from "./select_config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a52145ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a52145ee')) {
      api.createRecord('a52145ee', component.options)
    } else {
      api.reload('a52145ee', component.options)
    }
    module.hot.accept("./select_config.vue?vue&type=template&id=a52145ee&scoped=true", function () {
      api.rerender('a52145ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/components/select_org_cus_ter/select_config.vue"
export default component.exports